// src/store/modules/invoices.js
import {
  fetchInvoices as apiFetchInvoices,
  createInvoice as apiCreateInvoice,
  markInvoicePaid as apiMarkInvoicePaid,
  removeInvoicePaidMark as apiRemoveInvoicePaidMark,
  deleteInvoice as apiDeleteInvoice
} from '@/api/invoices'

export default {
  namespaced: true,
  state: () => ({
    all: [],          // all invoices
    loading: false,   // loading state for UI spinners
    error: null       // last error message
  }),
  mutations: {
    SET_INVOICES(state, invoices) {
      state.all = invoices
    },
    ADD_INVOICE(state, invoice) {
      state.all.unshift(invoice)
    },
    REMOVE_INVOICE(state, id) {
      state.all = state.all.filter(inv => inv.id !== id)
    },
    UPDATE_INVOICE(state, { invoiceId, fields }) {
      const idx = state.all.findIndex(inv => (inv.invoiceId ?? inv.id) === invoiceId)
      if (idx !== -1) {
        state.all[idx] = { ...state.all[idx], ...fields }
      }
    },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchInvoices({ commit }, params = {}) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const invoices = await apiFetchInvoices(params)
        commit('SET_INVOICES', invoices)
        return invoices
      } catch (e) {
        commit('SET_ERROR', e.response?.data || e.message)
        throw e
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async createInvoice({ commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const res = await apiCreateInvoice(payload)
        const invoice = res.data ?? res
        //commit('ADD_INVOICE', invoice)
        return invoice
      } catch (e) {
        commit('SET_ERROR', e.response?.data || e.message)
        throw e
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async markInvoicePaid({ commit }, invoiceId) {
      try {
        const res = await apiMarkInvoicePaid(invoiceId)
        commit('UPDATE_INVOICE', { invoiceId, fields: { rocky_marked_paid: res.rocky_marked_paid } })
        return res
      } catch (e) {
        commit('SET_ERROR', e.response?.data || e.message)
        throw e
      }
    },
    async removeInvoicePaidMark({ commit }, invoiceId) {
      try {
        const res = await apiRemoveInvoicePaidMark(invoiceId)
        commit('UPDATE_INVOICE', { invoiceId, fields: { rocky_marked_paid: null } })
        return res
      } catch (e) {
        commit('SET_ERROR', e.response?.data || e.message)
        throw e
      }
    },
    async deleteInvoice({ commit }, invoiceId) {
      try {
        const res = await apiDeleteInvoice(invoiceId)
        commit('REMOVE_INVOICE', invoiceId)
        return res
      } catch (e) {
        commit('SET_ERROR', e.response?.data || e.message)
        throw e
      }
    }
  },
  getters: {
    allInvoices: state => state.all,
    invoiceById: state => id => state.all.find(inv => inv.id === id),
    isLoading: state => state.loading,
    lastError: state => state.error
  }
}
